import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import PropTypes from 'prop-types';
import Carousel from '../carousel/Carousel';
import FeaturePromo from '../feature-promo/FeaturePromo';
import Sidebar from '../sidebar/Sidebar';
import Service from '../service/Service';
var iaOffer = {
  'Ad_Carousel': Carousel,
  'Ad_Banner': Carousel,
  'Ad_Sidebar': Sidebar,
  'Ad_Feature': FeaturePromo,
  'Ad_Service': Service
};
export var IAOffers = function IAOffers(_ref) {
  var data = _ref.data;

  var _ref2 = data || {},
      _ref2$componentTempla = _ref2.componentTemplate;

  _ref2$componentTempla = _ref2$componentTempla === void 0 ? {} : _ref2$componentTempla;
  var title = _ref2$componentTempla.title,
      _ref2$ia_rendered = _ref2.ia_rendered,
      ia_rendered = _ref2$ia_rendered === void 0 ? '' : _ref2$ia_rendered;

  var _ia_rendered$split$re = ia_rendered.split(' ').reduce(function (acc, item) {
    var offer = item && item.match(/[=](.*)$/);

    if (offer) {
      acc.push(offer[1]);
    }

    return acc;
  }, []),
      _ia_rendered$split$re2 = _slicedToArray(_ia_rendered$split$re, 3),
      _ia_rendered$split$re3 = _ia_rendered$split$re2[0],
      slotId = _ia_rendered$split$re3 === void 0 ? '' : _ia_rendered$split$re3,
      _ia_rendered$split$re4 = _ia_rendered$split$re2[1],
      lang = _ia_rendered$split$re4 === void 0 ? '' : _ia_rendered$split$re4,
      _ia_rendered$split$re5 = _ia_rendered$split$re2[2],
      offerId = _ia_rendered$split$re5 === void 0 ? '' : _ia_rendered$split$re5;

  var Component = iaOffer[title];
  return Component ? /*#__PURE__*/React.createElement("div", {
    className: 'iaRendered',
    "data-slot-id": slotId,
    lang: lang,
    "data-offer-id": offerId
  }, /*#__PURE__*/React.createElement(Component, {
    data: data
  })) : null;
};
IAOffers.propTypes = {
  data: PropTypes.object.isRequired
};
export default IAOffers;